import type { HttpResponse } from 'services/apiService';

export const createBackendErrorMessage = (
  response: HttpResponse<unknown>
): string => `Error ${response.status} - 🤮 OHNOES!`;

export const createNetworkErrorMessage = (error: Error): string =>
  `Request failed ☠️  - ${error.message}`;

export const createErrorId = (errorType: string, errorCount: number): string =>
  `${errorType}#${errorCount}`;
